/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

let EditContractDialog = () => import('../../view/EditContractDialog')
let SignContractDialog = () => import('../../view/Client/SignContractDialog')


// import EditContractDialog from '../../view/EditContractDialog'
// import SignContractDialog from '../../view/Client/SignContractDialog'


import {createDialogLazy} from "@/utils/helpers-external.js";

export const editContractDialog = createDialogLazy(EditContractDialog)
export const signContractDialog = createDialogLazy(SignContractDialog)
